var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('icare-table',{ref:"table",attrs:{"title-config":_vm.titleConfig,"request-fun":_vm.requestFun,"table-pagination":true,"pagination-config":_vm.tableParams,"methods-data":"get_feedback","params":""}},[_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }